import ReactGA from "react-ga4";

const GA_ID = "G-JCRH7B0S1V"; 

export const initializeGA = () => {
  try {
    ReactGA.initialize(GA_ID);
    //console.log("[GA] Initialized with ID:", GA_ID);
  } catch (error) {
    console.error("[GA] Initialization error:", error);
  }
};

export const trackPageView = (path) => {
  try {
    ReactGA.send({ hitType: "pageview", page: path });
    console.log("[GA] Pageview tracked:", path);
  } catch (error) {
    console.error("[GA] Pageview error:", error);
  }
};

export const trackEvent = (category, action, label = "", value = undefined) => {
  try {
    const event = { category, action };
    if (label) event.label = label;
    if (value !== undefined) event.value = value;
    ReactGA.event(event);
    console.log("[GA] Event tracked:", event);
  } catch (error) {
    console.error("[GA] Event error:", error);
  }
};
